import { SoundManager } from './core/soundManager';

export let comboSoundList: string[] = [];
let soundsLoaded = false;
export function preloadGameSounds() {
    //one order
    if (soundsLoaded) return;
    soundsLoaded = true;

    SoundManager.preload('card_take', 'ogg,webm,mp3', 'cardTakeSFX');
    SoundManager.preload('card_flip', 'ogg,webm,mp3', 'flipCardSFX');
    SoundManager.preload('undo', 'ogg,webm,mp3', 'undoSFX');
    SoundManager.preload('card_put', 'ogg,webm,mp3', 'cardPutSFX');
    SoundManager.preload('card_put_empty', 'ogg,webm,mp3', 'cardPutEmptySFX');
    SoundManager.preload('start_new', 'ogg,webm,mp3', 'newGameSFX');
    SoundManager.preload('card_shake', 'ogg,mp3,webm', 'missCardSFX');
    SoundManager.preload('auto_complete_notice', 'ogg,webm,mp3', 'autocompleteShowSFX');
    SoundManager.preload('auto_complete', 'ogg,webm,mp3', 'autocompleteRunSFX');
    SoundManager.preload('empty column', 'ogg,webm,mp3', 'emptyColumnSFX');
    SoundManager.preload('hint', 'ogg,mp3,webm', 'hintSFX');
    SoundManager.preload('no_hints', 'mp3,ogg,webm', 'noHintSFX');

    SoundManager.preload('reward', 'ogg,webm,mp3', 'cardRewardSFX');
    SoundManager.preload('shuffle', 'ogg,webm,mp3', 'shuffleSFX');
    SoundManager.preload('deck_reverse', 'ogg,webm,mp3', 'flipDeckSFX');
    SoundManager.preload('result', 'ogg,webm,mp3', 'winPopupSFX');
    SoundManager.preload('magic_wand', 'webm,mp3,ogg', 'magicWandClickSFX');
    SoundManager.preload('mw_sound_action', 'webm,mp3,ogg', 'magicWandActionSFX');
    SoundManager.preload('win_stack_cards', 'ogg,webm,mp3', 'winStackSFX');

    for (let i = 1; i <= 14; i++) {
        const soundName = `card_${i}`;
        SoundManager.preload(soundName, 'ogg,webm,mp3', soundName);
        comboSoundList.push(soundName);
    }
    // Preload the combo sounds and add them to the comboSoundList (card_1, card_2 ... card_14)
}
